import React from 'react'
import useTrans from '@hooks/useTrans'
import { cn } from '@utils/safeTs'
import { History } from '@components/icons'
import styles from './CronologiaButton.module.sass'


interface Props {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  className?: string
}

const CronologiaButton = (props: Props) => {

  const { 
    onClick,
    className,
  } = props

  const t = useTrans()

  return (
    <button type="button" onClick={onClick} className={cn(styles.root, className)}>
      <span className={styles.label}>{t("Log")}</span>
      <History aria-hidden />
    </button>
  )
}

export default CronologiaButton
